<template>
    <div class="userInfo-wrapper" v-if="order.finance.invoice">
        <div class="userInfo-border">
            <h5>发票信息
                <el-button
                        v-if="order.finance_audit==params.TYPE_CHECKED && !$route.query['flow_type'] && Acs('/order/fill') && !order.close_audit && !order.order_sensitive_masked"
                        size="mini" type="primary"
                        @click="dialogInvoiceTable">补充发票
                </el-button>
                <span style="color:red;" v-if="order.finance && order.finance.total_amount">
                    &nbsp;待开票金额：{{ order.order_sensitive_masked ? '******' : order.finance.total_amount - wait_invoice_amount }}
                </span>
            </h5>
            <!-- 添加表单 -->
            <invoice-table :invoiceForm="invoiceForm" :isFillInvoice="true" v-if="dialogInvoiceVisible" :customer_id="order.customer_id" :contract-amount="order.finance && order.finance.total_amount" :invoices="order.finance && order.finance.invoice" @handleAddInvoice='fillInvoice' @success-address="refreshOrder"></invoice-table>
            <div class="userInfo-group" v-if="order.finance.invoice.length == 0"
                 style="text-align:center; font-size:14px; color:#909399;">暂无数据
            </div>
            <el-row class="userInfo-group" v-for="item in order.finance.invoice" :key="item.id" v-else>
              <el-row>
                    <el-col :span="12" class="order-item">发票编号：<span>{{ item.id }}</span></el-col>
              </el-row>
                <el-row>
                    <el-col :span="12" class="order-item">发票类型：<span>{{ types[item.type-1] }}</span></el-col>
                    <el-col :span="12" class="order-item">发票抬头：<span>{{item.title}}</span></el-col>
                </el-row>
                <el-row v-if="type.length > 0">
                    <el-col :span="12" class="order-item">开票内容：<span>{{getInvoiceContent(item.content)}}</span></el-col>
                    <el-col :span="12" class="order-item">开票金额：<span>{{item.total_amount}}</span></el-col>
                </el-row>
                <el-row>
                    <el-col :span="12" class="order-item">开票日期：<span>{{item.input_at}}</span></el-col>
                    <el-col :span="12" class="order-item">纳税人识别号：<span>{{item.taxpayer_id}}</span></el-col>
                </el-row>
                <el-row>
                    <el-col :span="12" class="order-item"></el-col>
                    <el-col :span="12" class="order-item">开票明细：<span>{{ getInvoiceDetailText(item) }}</span></el-col>
                </el-row>
                <el-row>
                    <el-col :span="12" class="order-item">是否开具发票：<span>{{item.issue?'是':'否'}}</span></el-col>
                    <el-col :span="12" class="order-item">申请开票日期：<span>{{item.apply_open_at}}</span></el-col>
                </el-row>
                <el-row>
                    <el-col :span="12" class="order-item">是否作废：<span>{{item.is_delete?'是':'否'}}</span></el-col>
                    <el-col :span="12" class="order-item">需要寄件：<span>{{item.is_logistic ? '是' : '否'}}</span></el-col>
                </el-row>
                <el-row>
                    <el-col :span="12" class="order-item">开户行：<span>{{item.bank_name}}</span></el-col>
                    <el-col :span="12" class="order-item">账号：<span>{{item.account}}</span></el-col>
                </el-row>
                <el-row>
                    <el-col :span="12" class="order-item">电话：<span>{{item.mobile}}</span></el-col>
                    <el-col :span="12" class="order-item">地址：<span>{{item.address}}</span></el-col>
                </el-row>
                <el-row>
                    <el-col :span="12" class="order-item">邮箱：<span>{{item.email}}</span></el-col>
                    <el-col :span="12" class="order-item">备注：<span>{{item.memo}}</span></el-col>
                </el-row>
                <el-row>
                    <el-col :span="12" class="order-item">附件：<span v-for="atta in item.file_list"><a :href="atta.file_path ||atta.url " target="_blank"><i class="el-icon-document"></i>{{atta.name||atta.file_name}}</a></span></el-col>
                </el-row>
                <el-button size="mini" type="primary"
                         v-if="item.issue == 0 && Acs('/order/delete-invoice') && !order.order_sensitive_masked" @click="drop(item)">删除
                    </el-button>
<!--                <el-button size="mini" type="primary"-->
<!--                           v-if="order.finance_audit==params.TYPE_CHECKED && !item.issue && Acs('/order/issue') &&   !$route.query['flow_type']"-->
<!--                           @click="issue(item)">开票-->
<!--                </el-button>-->
            </el-row>
        </div>
    </div>
</template>
<script>
    import {OrderMixin} from "~/services/OrderMixin";
    import OrderService from "~/services/order";
    import InvoiceTable from "~/views/order/invoiceTable.vue";
    import CustomerService from "~/services/customer"

    export default {
        mixins: [OrderMixin],

        props: {
            order: {
                required: true
            },
        },

        data() {
            return {
                type: [],
                invoiceForm: null, // 发票表单
                dialogInvoiceVisible: false, //发票弹窗
                types:[
                    "普通发票(纸质)",
                    "专用发票(纸质)",
                    "普通发票(电子)",
                    "专用发票(电子)"
                ],
            }
        },

        components: {
            InvoiceTable
        },

        mounted() {
          OrderService.myInvoiceContext([0, 1]).then(res => {
            if(res.code==0) {
              this.type = res.data;
            }
          })

        },

        computed: {
            wait_invoice_amount() {
                if (this.order.order_sensitive_masked) {
                    return 0;
                }
                return this.order.finance.invoice.reduce(function (sum, item) {
                    if (item.is_delete != 1) {
                        return sum + parseFloat(item.total_amount);
                    } else {
                        return sum;
                    }
                }, 0);
            }
        },

        methods: {
            /** @description 获取发票内容的显示文本 */
            getInvoiceContent(contentId) {
                // 确保contentId是字符串类型以便比较
                const id = String(contentId);
                const found = this.type.find(item => String(item.value) === id);
                return found ? found.label : contentId;
            },

            /** @description 添加发票信息*/
            dialogInvoiceTable() {
                this.getLastInvoice(this.order.customer_id);
            },

            getLastInvoice(customerId) {
                CustomerService.getLastInvoice(customerId).then(res => {

                    if (res.code == 0 && res.data.title) {
                        let invoice = res.data;
                        this.invoiceForm = {
                            type: invoice.type,
                            title: invoice.title,
                            content: invoice.content ? parseInt(invoice.content) : '',
                            total_amount: invoice.total_amount,
                            input_at: '',
                            taxpayer_id: invoice.taxpayer_id,
                            bank_name: invoice.bank_name,
                            account: invoice.account,
                            mobile: invoice.mobile,
                            email: invoice.email,
                            address: invoice.address,
                            file_list: invoice.file_list,
                            attachment_ids: '',
                            order_id: this.order.id,
                            memo: invoice.content_memo,
                            // 判断是否是补充发票类型，如果是则默认选中申请开票
                            apply_open: this.$route.query['type'] == this.params.FILL_INVOICE ? true : false,
                            // 合同盖章默认为false
                            contract_seal: false
                        };
                    } else {
                        this.invoiceForm = {
                            // 判断是否是补充发票类型，如果是则默认选中申请开票
                            apply_open: this.$route.query['type'] == this.params.FILL_INVOICE ? true : false,
                            // 合同盖章默认为false
                            contract_seal: false
                        };
                    }

                    this.dialogInvoiceVisible = true;

                    return;
                }).catch(err => {
                    this.invoiceForm = {
                        // 判断是否是补充发票类型，如果是则默认选中申请开票
                        apply_open: this.$route.query['type'] == this.params.FILL_INVOICE ? true : false,
                        // 合同盖章默认为false
                        contract_seal: false
                    };
                    this.dialogInvoiceVisible = true;
                })
            },
            getInvoiceDetailText(item) {
                const rows = (item && (item.detail || item.details)) || [];
                if (!Array.isArray(rows) || rows.length === 0) return '';
                return rows
                    .filter(r => r && (r.product_name || r.model))
                    .map(r => `${r.product_name || r.model}-${r.unit || ''}-${r.num || r.qty || ''}`)
                    .join('，');
            },

            issue(data) {
                this.$confirm('是否开具发票?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'info'
                }).then(() => {
                    OrderService.issue(data).then(res => {
                        if (res.code == 0) {
                            this.$message({
                                type: 'success',
                                message: '开具成功!'
                            });
                            this.getOrder(this.id);
                        }
                    })
                })
            },

            fillInvoice(form) {
                if (form) {
                    if (form.file_list instanceof Array && form.file_list.length > 0) {
                        for (var i = 0; i < form.file_list.length; i++) {
                            form.attachment_ids += form.file_list[i]['id'] + ','
                        }
                        form.attachment_ids = form.attachment_ids.substring(0, form.attachment_ids.lastIndexOf(','));
                    }
                    form.order_id = this.id;
                    OrderService.fillInvoice(form).then(res => {
                        if (res.code == 0) {
                            this.$message({
                                type: 'success',
                                message: '补充发票成功，等待审核!'
                            });
                            this.dialogInvoiceVisible = false;
                            this.getOrder(this.id);
                        }
                    });
                } else {
                    this.dialogInvoiceVisible = false;
                }
            },

            drop(form){
                this.$confirm('你确认要删除这笔发票吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'info'
                }).then(() => {
                    OrderService.deleteInvoice({ids: [form.id]}).then(res => {
                        if (res.code == 0) {
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            this.getOrder(this.id);
                        }
                    })
                })
            },
            refreshOrder() {
                this.getOrder(this.id);
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/views/order/partial/order_invoice.vue